/**
 * This module is intended to be consumed by any other module
 * you may create.  Please declare and export anything that is shared
 * except for Services - those should be in the core app.module
 *
 * the services are done this way so all modules use the same injected
 * instance.  If you need your module to instance a new variant, feel free
 * to overwrite this (but do so with caution)
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { DebugComponent } from './components/debug/debug.component';
import { TranslatePipe } from './pipes/translate.pipe';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SafePipe } from './pipes/safe.pipe';

import { DlDateTimeModule } from './modules/dl-date-time/dl-date-time.module';
import { QrcodeComponent } from './components/qrcode/qrcode.component';
import { BarcodeComponent } from './components/barcode/barcode.component';


@NgModule({
	declarations: [ // components, directives and pipes
		DebugComponent,
		ConfirmDialogComponent,
		TranslatePipe,
		SafePipe,
		QrcodeComponent,
		BarcodeComponent,
	],
	imports: [
		CommonModule,

		// material modules USED explicitly by the shared/components and what not
		MatButtonModule,
		MatDialogModule,
		DlDateTimeModule,
	],
	providers: [
		TranslatePipe,
		SafePipe,
		{provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 3000, horizontalPosition: 'center', verticalPosition: 'top'}},
	],
	exports: [
		// the common shit
		CommonModule,

		// forms
		FormsModule,
		ReactiveFormsModule,

		// material - export all of the common.  tree shaking "should" get rid of these if unused
		MatIconModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
		MatToolbarModule,
		MatDialogModule,
		MatMenuModule,
		MatDividerModule,
		MatSnackBarModule,
		MatNativeDateModule,
		MatTooltipModule,
		MatListModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatSelectModule,

		// export our shared components & pipes
		DebugComponent,
		ConfirmDialogComponent,
		TranslatePipe,
		SafePipe,

		DlDateTimeModule,
		QrcodeComponent,
		BarcodeComponent,
	]
})
export class SharedModule { }


